import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
import { ComplaintEntity } from "./complaint.entity";

@Entity('complaint_files')
export class ComplaintFilesEntity { 

    @PrimaryGeneratedColumn('increment',{name:'id'}) 
    Id: number; 
   
      @Column({
        type: 'int',
        nullable:false,
        name: 'complaint_id'
    })
    complaintId: number;
      @Column("varchar",{
        nullable: true,
        length:500,
        name:"attachments_url"
      })
      attachmentsUrl:string;
    @ManyToOne(() =>ComplaintEntity,(complaint:ComplaintEntity)=>complaint.complaintfiles)
    @JoinColumn({name:"complaint_id"})
    complaint:ComplaintEntity;
   
}